<h2 class="_sansSerif _primary"[i18nKey]="'intro.human-resources.title'"></h2>

<kiwi-spacer [size]="24"></kiwi-spacer>

<p [i18nKey]="'intro.humanResources.paragraph.1'"></p>

<p [innerHTML]="'intro.humanResources.paragraph.2'|translate" [i18nKey]="[{target: 'innerHTML', key: 'intro.humanResources.paragraph.2'}]"></p>
<p [i18nKey]="'intro.humanResources.paragraph.3'"></p>

<kiwi-spacer [size]="16"></kiwi-spacer>
<h3 [i18nKey]="'intro.humanResources.paragraph.4'"></h3>
<p [i18nKey]="'intro.humanResources.paragraph.5'"></p>

<kiwi-spacer [size]="16"></kiwi-spacer>
<h3 [i18nKey]="'intro.humanResources.paragraph.6'"></h3>

<kiwi-spacer [size]="4"></kiwi-spacer>

<div class="grid-x">
    <div class="cell small-12">
        <p [i18nKey]="'intro.humanResources.paragraph.7'"></p>
        <div class="groupItems">
            <div class="groupItems-item"[i18nKey]="'intro.humanResources.element.1'"></div>
            <div class="groupItems-item"[i18nKey]="'intro.humanResources.element.2'"></div>
        </div>
    </div>

    <div class="cell small-12">
        <p [i18nKey]="'intro.humanResources.paragraph.8'"></p>
        <div class="groupItems">
            <div class="groupItems-item"[i18nKey]="'intro.humanResources.element.3'"></div>
            <div class="groupItems-item"[i18nKey]="'intro.humanResources.element.4'"></div>
        </div>
    </div>
</div>

<kiwi-spacer [size]="4"></kiwi-spacer>

<p [i18nKey]="'intro.humanResources.paragraph.9'"></p>

<kiwi-spacer [size]="16"></kiwi-spacer>
<h3 [i18nKey]="'intro.humanResources.paragraph.10'"></h3>
<kiwi-spacer [size]="4"></kiwi-spacer>
<div class="grid-x">
    <div class="cell small-12">
        <p [i18nKey]="'intro.humanResources.paragraph.11'"></p>
        <div class="groupItems">
            <div class="groupItems-item"[i18nKey]="'intro.humanResources.element.5'"></div>
            <div class="groupItems-item"[i18nKey]="'intro.humanResources.element.6'"></div>
            <div class="groupItems-item"[i18nKey]="'intro.humanResources.element.7'"></div>
        </div>
    </div>
    <div class="cell small-12">
        <p [i18nKey]="'intro.humanResources.paragraph.12'"></p>
        <div class="groupItems">
            <div class="groupItems-item"[i18nKey]="'intro.humanResources.element.8'"></div>
            <div class="groupItems-item"[i18nKey]="'intro.humanResources.element.9'"></div>
            <div class="groupItems-item"[i18nKey]="'intro.humanResources.element.10'"></div>
        </div>
    </div>
</div>
<kiwi-spacer [size]="4"></kiwi-spacer>
<p [i18nKey]="'intro.humanResources.paragraph.13'"></p>
<p [i18nKey]="'intro.humanResources.paragraph.14'"></p>
<p [i18nKey]="'intro.humanResources.paragraph.15'"></p>
